import React, { useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import './App.css';
import Projects from './components/Projects';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';

const App = () => {
  const [isFading, setIsFading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    setIsFading(true);
    setTimeout(() => {
      navigate(path);
      setIsFading(false);
    }, 500);
  };

  return (
    <div>
      <div className={`content ${isFading ? 'fade-out' : 'fade-in'}`}>
        <Routes location={location}>
          <Route path="/" element={<Home onNavigate={handleNavigation} />} />
          <Route path="/about" element={<About onNavigate={handleNavigation} />} />
          <Route path="/projects" element={<Projects onNavigate={handleNavigation} />} />
          <Route path="/contact" element={<Contact onNavigate={handleNavigation} />} />
          <Route path="/:appName/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
